<template>

  <div class="mainLayout">
        <MainHeader/>
        <router-view class="mainLayout__topSpacer"></router-view>
        <MainFooter/>
  </div>
</template>

<script>

import MainHeader from "@/components/MainHeader/MainHeader.vue";
import MainFooter from "@/components/MainFooter/MainFooter.vue";

export default {
  name: "MainLayout",
  components: {MainFooter, MainHeader},
}
</script>


<style scoped lang="scss">

.mainLayout {
  // Горизонтальные отступы через padding, чтобы max-width работал корректно.
  // На экранах шире 1512px контент остаётся на месте, растут поля.
  max-width: $layout-max-width;
  margin: 36px auto;
  padding: 0 $layout-margin-xl;
  text-align: center;

  @include respond-to('xl') { padding: 0 $layout-margin-lg; }
  @include respond-to('lg') { margin-top: 24px; padding: 0 $layout-margin-md; }
  @include respond-to('md') { margin-top: 16px; padding: 0 $layout-margin-sm; }
  @include respond-to('xs') { margin-top: 12px; padding: 0 $space-sm; }

  &__topSpacer {
    margin-top: 60px;
    @include respond-to('md') { margin-top: 32px; }
  }
}

</style>
